import { render } from "./MeusPedidos.vue?vue&type=template&id=706b0f94&scoped=true"
import script from "./MeusPedidos.vue?vue&type=script&lang=js"
export * from "./MeusPedidos.vue?vue&type=script&lang=js"

import "./MeusPedidos.vue?vue&type=style&index=0&id=706b0f94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706b0f94"]])

export default __exports__